import classNames from 'classnames';
import { HTMLAttributes, PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';
import { IsVisible } from '../../../utils';

interface IModalRootProps extends HTMLAttributes<HTMLDivElement> {
  backdrop?: React.ReactNode;
  open: boolean;
}

export function ModalRoot({
  backdrop,
  children,
  className = '',
  open,
  ...rest
}: PropsWithChildren<IModalRootProps>) {
  return (
    <div
      className={classNames('fixed z-[100] inset-0', {
        block: open,
        hidden: !open,
      })}
      role="dialog"
      {...rest}
    >
      <IsVisible when={!!backdrop}>{backdrop}</IsVisible>
      <div
        className={classNames(
          twMerge(
            'flex items-center h-full transition-opacity duration-300',
            className,
          ),
          {
            'visible opacity-100': open,
            'invisible opacity-0': !open,
          },
        )}
        role="presentation"
        tabIndex={-1}
      >
        {children}
      </div>
    </div>
  );
}
